<template>
  <div class="min-h-screen flex flex-col">
    <!-- Global Navigation -->
    <TopNav>
      <template #actions>
        <slot name="nav-actions"></slot>
      </template>
    </TopNav>

    <!-- Main Content Area -->
    <div class="flex-1 bg-white">
      <!-- Optional breadcrumbs section -->
      <nav v-if="$slots.breadcrumbs" 
           class="bg-white border-b" 
           aria-label="Breadcrumb">
        <div class="mx-auto px-4 py-2">
          <slot name="breadcrumbs"></slot>
        </div>
      </nav>

      <!-- Main page content -->
      <div class="mx-auto bg-white">
        <router-view />
      </div>
    </div>

    <!-- Locations -->
    <OurLocations v-if="route.path !== '/locations'" />
    <Footer />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useHead } from '@vueuse/head'
import TopNav from '../components/TopNav.vue'
import OurLocations from '../components/OurLocations.vue'
import Footer from '../components/Footer.vue'

const route = useRoute()

const title = computed(() => route.meta.title as string)
const subtitle = computed(() => route.meta.subtitle as string)
const description = computed(() => route.meta.description as string)

useHead({
  title: computed(() => title.value + (subtitle.value ? ` | ${subtitle.value}` : '')),
  meta: [
    {
      name: 'description',
      content: description
    },
    {
      property: 'og:title',
      content: title
    },
    {
      property: 'og:description',
      content: description
    }
  ]
})
</script>

<script lang="ts">
export default {
  name: 'DefaultLayout'
}
</script>